module.exports = __webpack_public_path__ + "img/geo.16f859b5.svg";